const BuySell = [
    {id: "0", value: "買"},    
    {id: "1", value: "賣"}
  ];  
  
export default BuySell  